<template>
  <div>
    <span class="product-aside-price product-aside-price--fallback-price">
      Price for {{ fallbackPrice.country_name }}
    </span>

    <div class="product-aside-prices">
      <span v-if="hasDiscount" class="product-aside-price product-aside-price--discounted">
        <span class="product-aside-price-was">Was {{ fallbackPrice.compare_at_price_formatted_plus_vat }}</span>
        <span class="product-aside-price-now">Now {{ fallbackPrice.price_formatted_plus_vat }}</span>
      </span>
      <span v-else :class="priceClass">{{ fallbackPrice.price_formatted_plus_vat }}</span>
      <span v-if="hasDiscount" class="product-aside-price-exvat product-aside-price-exvat--discounted">
        <span class="product-aside-price-exvat-was">Was {{ fallbackPrice.compare_at_price_formatted }} (Ex.VAT)</span>
        <span class="product-aside-price-exvat-now">Now {{ fallbackPrice.price_formatted }} (Ex.VAT)</span>
      </span>
      <span v-else :class="priceExVatClass">{{ fallbackPrice.price_formatted }} (Ex.VAT)</span>
    </div>
  </div>
</template>

<script>
import { mapKeys, head } from "lodash";

export default {
  props: {
    product: Object,
    priceExVatClass: String,
    priceClass: String
  },
  computed: {
    hasDiscount() {
      return Boolean(
        this.fallbackPrice &&
        this.fallbackPrice.is_discounted &&
        this.fallbackPrice.compare_at_price_formatted_plus_vat &&
        this.fallbackPrice.price_formatted_plus_vat
      );
    },
    fallbackPrice() {
      const marketPrices = (this.product && this.product.market_prices) || [];
      if (!marketPrices.length) {
        return {};
      }
      const allMarketPrices = mapKeys(marketPrices, value => value.country_code || '');
      return allMarketPrices['IE'] || head(allMarketPrices);
    }
  }
};
</script>
